import { render, staticRenderFns } from "./LayoutReport.vue?vue&type=template&id=6771cb5e&"
import script from "./LayoutReport.vue?vue&type=script&lang=js&"
export * from "./LayoutReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports